import React, { useState } from 'react'
import { generateDocument } from '../services/docGenerator'

const DocumentGenerator = ({ 
  documentType, 
  selectedAccount, 
  selectedContact, 
  selectedProducts, 
  products,
  documentDate, 
  pricing,
  disabled 
}) => {
  const [generating, setGenerating] = useState(false)
  const [error, setError] = useState(null)

  const handleGenerate = async () => {
    try {
      setGenerating(true)
      setError(null)

      const documentData = {
        documentType,
        customer: selectedAccount,
        contact: selectedContact,
        selectedProducts,
        products,
        documentDate,
        pricing,
        documentId: `${documentType.toUpperCase()}-${Date.now()}`
      }

      await generateDocument(documentData)
    } catch (err) {
      console.error('Error generating document:', err)
      setError('Failed to generate document. Please try again.')
    } finally {
      setGenerating(false)
    }
  }

  return (
    <div className="border-t pt-6">
      {error && (
        <div className="mb-4 p-4 bg-red-50 border border-red-300 rounded text-red-800">
          {error}
        </div>
      )}

      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-medium text-gray-900">Generate Document</h3>
          <p className="mt-1 text-sm text-gray-600">
            {documentType === 'price-info' 
              ? 'Generate a price information sheet with selected products'
              : 'Generate a full contract document with terms and conditions'}
          </p>
        </div>
        <button
          onClick={handleGenerate}
          disabled={disabled || generating}
          className={`px-6 py-3 rounded-md font-medium text-white transition-colors ${
            disabled || generating
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'
          }`}
        >
          {generating ? (
            <span className="flex items-center">
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Generating...
            </span>
          ) : (
            `Generate ${documentType === 'price-info' ? 'Price Info' : 'Contract'}`
          )}
        </button>
      </div>

      {!disabled && (
        <div className="mt-4 p-4 bg-blue-50 rounded-lg">
          <h4 className="font-medium text-blue-900 mb-2">Document will include:</h4>
          <ul className="list-disc list-inside text-sm text-blue-800 space-y-1">
            <li>Customer information: {selectedAccount?.Name}</li>
            <li>Contact person: {selectedContact?.Name || 'Not selected'}</li>
            <li>Selected products: {selectedProducts.length} item(s)</li>
            <li>Total value: €{pricing.total.toFixed(2)}/month</li>
            {pricing.hasDiscount && <li>Bundle discount applied: 10% off</li>}
          </ul>
        </div>
      )}
    </div>
  )
}

export default DocumentGenerator